module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-13.b5089c71.png";